import createMetadataAPIOperations from '../../utils/api-metadata-operations';

const options = {
  name: 'groups',
  baseType: 'GROUPS',
  apiEndpoint: 'groups'
};

const defaultOperations = createMetadataAPIOperations(options);
const fetchGroups = defaultOperations.fetch;

// fetch a group, then fetch its substations
const fetchGroupAndSubgroups = (groupId, params, headers) => dispatch => {
  if (!groupId) return Promise.resolve();
  return dispatch(fetchGroups({ params: { ancestor_group_id: groupId }, headers }));
};

export default {
  ...defaultOperations,
  fetchGroupAndSubgroups
};
